import React, { useEffect, useState } from "react";
import styles from "./calenderTop.module.scss";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Tooltip } from "antd";
import moment from "moment";
import { getMeetingByDate } from "../../../../base/meetingService/apiService";
import _ from "lodash";
import { genCalendarObj } from "../../../../base/utils";
export default function CalederTopSection() {
  const settings = {
    infinite: true,
    speed: 300,
    slidesToShow: 14,
    slidesToScroll: 14,
    initialSlide:(new Date().getDate() > 15 ? new Date().getDate()-new Date().getDate() : new Date().getDate()-1),
    nextArrow: <div><div className={styles.prevNxt}>
      <Tooltip placement="top" title="Previous 14 days">
        <span className="icon_belloutline" ></span></Tooltip></div></div>,
    prevArrow: <div><div className={styles.prevNxt}>
      <Tooltip placement="top" title="Next 14 days"><span className="icon_belloutline" ></span></Tooltip></div></div>

  };

  type calendarTopState = {
    selectedMonth: any;
    selectedDay: any;
    selectedDate: any;
    selectedYear: any;
    selectedDateString: any;
    yearDates:any;
    currentMonthdates:any;
    filterDate:any;
    displayDate:any;
    sliderSettings:any
    
  }
  const [getData, setData] = useState<calendarTopState>({
    selectedMonth: new Date().getMonth()+1, selectedDay: moment(new Date()).format("ddd"),
    selectedDate: new Date().getDate(), selectedYear: moment(new Date()).format("YYYY"),
    selectedDateString:moment("YYYY MM DD"), yearDates : [], currentMonthdates : [], filterDate:"", displayDate:"Today", sliderSettings:settings
  });




 /*  for(var item of calendarDates.date){
    console.log("day", item.day);
 } */
  

//const [result, setResult] = useState<any>([]);
useEffect(() => {
const curDate = new Date();
getMeetingByDate(moment(curDate).format("YYYY-MM-DD"));

let calendarDates = genCalendarObj(`${new Date().getFullYear()}-01-01`, `${new Date().getFullYear()}-12-31`);
let calendar_arr:any  = calendarDates.date;
let currentMonth = new Date().getMonth()+1;
let currentMonthDates = _.filter(calendar_arr, function(o) { 
return o.month === currentMonth; 
});
let intialSlider:any = settings;
intialSlider.initialSlide = new Date().getDate();
setData({ ...getData, yearDates: calendar_arr, currentMonthdates:currentMonthDates, filterDate:moment(curDate).format("YYYY-MM-DD"), sliderSettings: intialSlider});
},[])

  const selectMonth = (month: any) => {
    let { selectedYear, selectedDate, yearDates } = getData;
    let currentMonthDates:any = _.filter(yearDates, function(o) { 
    return o.month === month; 
    });
    let modselectedMonth:any = month;
    if(modselectedMonth < 10){
    modselectedMonth = `0${modselectedMonth}`
    }
    let filterDate = `${selectedYear}-${modselectedMonth}-${selectedDate}`;
    getMeetingByDate(filterDate);
    setData({ ...getData, selectedMonth: month, currentMonthdates:currentMonthDates, filterDate });
  };

  const getDay = (day: any) => {
    setData({ ...getData, selectedDay: day });
  };

  const getDate = (date: any, day:any) => {

    getMeetingByDate(date);
    let filterDate =  moment(new Date()).format("YYYY-MM-DD");
    let displayDate = date;
    if(filterDate === date) displayDate = "Today"

    setData({ ...getData, selectedDate: day, filterDate: date, displayDate});
  };

  const goToday=()=>{
    let currentDate = new Date().getDate();
    let currentMonth = new Date().getMonth()+1;
    let currentYear = new Date().getFullYear();

    let calendarDates = genCalendarObj(`${currentYear}-01-01`, `${currentYear}-12-31`);

   let filterDate =  moment(new Date()).format("YYYY-MM-DD");

   let currentMonthDates = _.filter(calendarDates.date, function(o) { 
    return o.month === currentMonth; 
    });

   getMeetingByDate(filterDate);
   setData({ ...getData, selectedDate: currentDate, filterDate: filterDate, selectedMonth:currentMonth, selectedYear:currentYear.toString(), yearDates:calendarDates.date, currentMonthdates:currentMonthDates});

  }

  const yearChange =(type:any)=>{
      let {selectedYear, selectedMonth, selectedDate} = getData;
 
      if(type === 'prev')
      selectedYear = parseInt(selectedYear)-1;
      else
      selectedYear = parseInt(selectedYear)+1;

      let calendarDates = genCalendarObj(`${selectedYear}-01-01`, `${selectedYear}-12-31`);
      let modselectedMonth:any = selectedMonth;
      if(modselectedMonth < 10){
      modselectedMonth = `0${modselectedMonth}`
      }
      let filterDate = `${selectedYear}-${modselectedMonth}-${selectedDate}`
      getMeetingByDate(filterDate);    
      var calendar_arr:any  = calendarDates.date;
      let currentMonth = selectedMonth;

      let currentMonthDates = _.filter(calendar_arr, function(o) { 
      return o.month === currentMonth; 
      });

      setData({...getData, selectedYear, currentMonthdates:currentMonthDates, yearDates:calendar_arr});

  }

  return (
    <>
      <div className={styles.calenderTopSection}>
        <div className={styles.calenderFirstrow}>
          <div className={styles.todayBtn} onClick={goToday}>Today</div>
          <div className={styles.yearBtn}>
            <Tooltip placement="top" title="Previous"><span className="icon_searchlft"
               onClick={()=>yearChange('prev')}></span></Tooltip>
           <div id="yearSec" className={styles.yearText}> {getData.selectedYear}</div><Tooltip placement="top"
              title="Next"><span className="icon_searchrgt" onClick={()=>yearChange('next')}></span></Tooltip></div>
          <div className={styles.monthSec}>
            <span className={getData.selectedMonth === 1 ?
              `${styles.monthName} ${styles.selectedMonth}` : `${styles.monthName}`}
            onClick={() => selectMonth(1)}>JAN</span>
            <span className={getData.selectedMonth === 2 ?
              `${styles.monthName} ${styles.selectedMonth}` : `${styles.monthName}`}
            onClick={() => selectMonth(2)}>FEB</span>
            <span className={getData.selectedMonth === 3 ?
              `${styles.monthName} ${styles.selectedMonth}` : `${styles.monthName}`}
            onClick={() => selectMonth(3)}>MAR</span>
            <span className={getData.selectedMonth === 4 ?
              `${styles.monthName} ${styles.selectedMonth}` : `${styles.monthName}`}
            onClick={() => selectMonth(4)}>APR</span>
            <span className={getData.selectedMonth === 5 ?
              `${styles.monthName} ${styles.selectedMonth}` : `${styles.monthName}`}
            onClick={() => selectMonth(5)}>MAY</span>
            <span className={getData.selectedMonth === 6 ?
              `${styles.monthName} ${styles.selectedMonth}` : `${styles.monthName}`}
            onClick={() => selectMonth(6)}>JUN</span>
            <span className={getData.selectedMonth === 7 ?
              `${styles.monthName} ${styles.selectedMonth}` : `${styles.monthName}`}
            onClick={() => selectMonth(7)}>JULY</span>
            <span className={getData.selectedMonth === 8 ?
              `${styles.monthName} ${styles.selectedMonth}` : `${styles.monthName}`}
            onClick={() => selectMonth(8)}>AUG</span>
            <span className={getData.selectedMonth === 9 ?
              `${styles.monthName} ${styles.selectedMonth}` : `${styles.monthName}`}
            onClick={() => selectMonth(9)}>SEPT</span>
            <span className={getData.selectedMonth === 10 ?
              `${styles.monthName} ${styles.selectedMonth}` : `${styles.monthName}`}
            onClick={() => selectMonth(10)}>OCT</span>
            <span className={getData.selectedMonth === 11 ?
              `${styles.monthName} ${styles.selectedMonth}` : `${styles.monthName}`}
            onClick={() => selectMonth(11)}>NOV</span>
            <span className={getData.selectedMonth === 12 ?
              `${styles.monthName} ${styles.selectedMonth}` : `${styles.monthName}`}
            onClick={() => selectMonth(12)}>DEC</span>
          </div>


        </div>
        <div className={styles.calenderSecondrow}>
          <div className={styles.dayCal}>
{/*             <div className={styles.slidDay}>
              <span className={styles.datText} onClick={()=>getDay("sun")}>s</span>
              <span className={styles.datText} onClick={()=>getDay("mon")}>m</span>
              <span className={styles.datText} onClick={()=>getDay("tue")}>t</span>
              <span className={styles.datText} onClick={()=>getDay("wed")}>w</span>
              <span className={styles.datText} onClick={()=>getDay("thur")}>t</span>
              <span className={styles.datText} onClick={()=>getDay("fri")}>f</span>
              <span className={styles.datText} onClick={()=>getDay("sat")}>s</span>
              <span className={styles.datText} onClick={()=>getDay("sun")}>s</span>
              <span className={styles.datText} onClick={()=>getDay("mon")}>m</span>
              <span className={styles.datText} onClick={()=>getDay("tue")}>t</span>
              <span className={styles.datText} onClick={()=>getDay("wed")}>w</span>
              <span className={styles.datText} onClick={()=>getDay("thur")}>t</span>
              <span className={styles.datText} onClick={()=>getDay("fri")}>f</span>
              <span className={styles.datText} onClick={()=>getDay("sat")}>s</span>
            </div> */}

{/*             {
              result.map((value:any, index:any)=>{

                return(
                  <>
                  <p>
                    {value.toString()}
                  </p>
                  </>
                )
              })
            } */}
            <Slider {...settings} className="calSlider">

{
  getData.currentMonthdates.map((date:any, index:any)=>{

    return(

      <>
       
        <div className={(getData.selectedDate === date.day && date.acutulDate === moment(new Date()).format("YYYY-MM-DD")) ? ` ${styles.dateNum} ${styles.currentDate} ${styles.dateSelected}` : date.acutulDate === moment(new Date()).format("YYYY-MM-DD") ? ` ${styles.dateNum} ${styles.currentDate}`
          : getData.selectedDate === date.day ? `${styles.dateNum} ${styles.dateSelected}`
                : `${styles.dateNum}`}>
                  <span className={styles.datText} onClick={()=>getDay("sun")}>{date.dayname}</span>
                <span className={styles.dates} onClick={() => getDate(date.acutulDate, date.day)}>{date.day}</span>
                <span className={styles.dotAvail}></span>
              </div>
      </>
    )
  })
}

{/*               <div className={getData.selectedDate === "01" ? `${styles.dateNum} ${styles.dateSelected}`
                : `${styles.dateNum}`}>
                <span className={styles.dates} onClick={() => getDate("01")}>1</span>
                <span className={styles.dotAvail}></span>
              </div>
              <div className={getData.selectedDate === "02" ? `${styles.dateNum} ${styles.dateSelected}`
                : `${styles.dateNum}`}>
                <span className={styles.dates} onClick={() => getDate("02")}>2</span>
                <span className={styles.dotAvail}></span>
              </div>
              <div className={getData.selectedDate === "03" ? `${styles.dateNum} ${styles.dateSelected}`
                : `${styles.dateNum}`}>
                <span className={styles.dates} onClick={() => getDate("03")}>3</span>
                <span className={styles.dotAvail}></span>
              </div>
              <div className={getData.selectedDate === "04" ? `${styles.dateNum} ${styles.dateSelected}`
                : `${styles.dateNum}`}>
                <span className={styles.dates} onClick={() => getDate("04")}>4</span>
                <span className={styles.dotAvail}></span>
              </div>
              <div className={getData.selectedDate === "05" ? `${styles.dateNum} ${styles.dateSelected}`
                : `${styles.dateNum}`}>
                <span className={styles.dates} onClick={() => getDate("05")}>5</span>
                <span className={styles.dotAvail}></span>
              </div>
              <div className={getData.selectedDate === "06" ? `${styles.dateNum} ${styles.dateSelected}`
                : `${styles.dateNum}`}>
                <span className={styles.dates} onClick={() => getDate("06")}>6</span>
                <span className={styles.dotAvail}></span>
              </div>
              <div className={getData.selectedDate === "07" ? `${styles.dateNum} ${styles.dateSelected}`
                : `${styles.dateNum}`}>
                <span className={styles.dates} onClick={() => getDate("07")}>7</span>
                <span className={styles.dotAvail}></span>
              </div>
              <div className={getData.selectedDate === "08" ? `${styles.dateNum} ${styles.dateSelected}`
                : `${styles.dateNum}`}>
                <span className={styles.dates} onClick={() => getDate("08")}>8</span>
                <span className={styles.dotAvail}></span>
              </div>
              <div className={getData.selectedDate === "09" ? `${styles.dateNum} ${styles.dateSelected}`
                : `${styles.dateNum}`}>
                <span className={styles.dates} onClick={() => getDate("09")}>9</span>
                <span className={styles.dotAvail}></span>
              </div>
              <div className={getData.selectedDate === "10" ? `${styles.dateNum} ${styles.dateSelected}`
                : `${styles.dateNum}`}>
                <span className={styles.dates} onClick={() => getDate("10")}>10</span>
                <span className={styles.dotAvail}></span>
              </div>
              <div className={getData.selectedDate === "11" ? `${styles.dateNum} ${styles.dateSelected}`
                : `${styles.dateNum}`}>
                <span className={styles.dates} onClick={() => getDate("11")}>11</span>
                <span className={styles.dotAvail}></span>
              </div>
              <div className={getData.selectedDate === "12" ? `${styles.dateNum} ${styles.dateSelected}`
                : `${styles.dateNum}`}>
                <span className={styles.dates} onClick={() => getDate("12")}>12</span>
                <span className={styles.dotAvail}></span>
              </div>
              <div className={getData.selectedDate === "13" ? `${styles.dateNum} ${styles.dateSelected}`
                : `${styles.dateNum}`}>
                <span className={styles.dates} onClick={() => getDate("14")}>13</span>
                <span className={styles.dotAvail}></span>
              </div>
              <div className={getData.selectedDate === "14" ? `${styles.dateNum} ${styles.dateSelected}`
                : `${styles.dateNum}`}>
                <span className={styles.dates} onClick={() => getDate("14")}>14</span>
                <span className={styles.dotAvail}></span>
              </div>
              <div className={styles.dateNum}>
                <span className={styles.dates} onClick={() => getDate("15")}>15</span>
                <span className={styles.dotAvail}></span>
              </div>
              <div className={styles.dateNum}>
                <span className={styles.dates} onClick={() => getDate("16")}>16</span>
                <span className={styles.dotAvail}></span>
              </div>
              <div className={styles.dateNum}>
                <span className={styles.dates} onClick={() => getDate("17")}>17</span>
                <span className={styles.dotAvail}></span>
              </div>
              <div className={styles.dateNum}>
                <span className={styles.dates} onClick={() => getDate("18")}>18</span>
                <span className={styles.dotAvail}></span>
              </div>
              <div className={styles.dateNum}>
                <span className={styles.dates} onClick={() => getDate("19")}>19</span>
                <span className={`${styles.dotAvail} ${styles.completed}`}></span>
              </div>
              <div className={`${styles.dateNum} ${styles.currentDate}`}>
                <span className={styles.dates} onClick={() => getDate("20")}>20</span>
                <span className={`${styles.dotAvail} ${styles.available}`}></span>
              </div>
              <div className={`${styles.dateNum} ${styles.dateSelected}`}>
                <span className={styles.dates} onClick={() => getDate("21")}>21</span>
                <span className={`${styles.dotAvail} ${styles.available}`}></span>
              </div>
              <div className={styles.dateNum}>
                <span className={styles.dates} onClick={() => getDate("22")}>22</span>
                <span className={styles.dotAvail}></span>
              </div>
              <div className={styles.dateNum}>
                <span className={styles.dates} onClick={() => getDate("23")}>23</span>
                <span className={styles.dotAvail}></span>
              </div>
              <div className={styles.dateNum}>
                <span className={styles.dates} onClick={() => getDate("24")}>24</span>
                <span className={styles.dotAvail}></span>
              </div>
              <div className={getData.selectedDate === "25" ? `${styles.dateNum} ${styles.dateSelected}`
                : `${styles.dateNum}`}>
                <span className={styles.dates} onClick={() => getDate("25")}>25</span>
                <span className={styles.dotAvail}></span>
              </div>
              <div className={styles.dateNum}>
                <span className={styles.dates} onClick={() => getDate("26")}>26</span>
                <span className={styles.dotAvail}></span>
              </div>
              <div className={styles.dateNum}>
                <span className={styles.dates} onClick={() => getDate("27")}>27</span>
                <span className={styles.dotAvail}></span>
              </div>
              <div className={styles.dateNum}>
                <span className={styles.dates} onClick={() => getDate("28")}>28</span>
                <span className={styles.dotAvail}></span>
              </div>
              <div className={styles.dateNum}>
                <span className={styles.dates} onClick={() => getDate("29")}>29</span>
                <span className={styles.dotAvail}></span>
              </div>
              <div className={styles.dateNum}>
                <span className={styles.dates} onClick={() => getDate("30")}>30</span>
                <span className={styles.dotAvail}></span>
              </div>
              <div className={styles.dateNum}>
                <span className={styles.dates} onClick={() => getDate("31")} >31</span>
                <span className={styles.dotAvail}></span>
              </div> */}
            </Slider>
          </div>
        </div>
      </div>
    </>
  );
};

